import React, { memo, useCallback } from 'react';
import { SearchTemplate } from '@app/templates';
import { Tender, TenderStatusNames } from '@app/models';
import { getTenders, PageableParams } from '@app/api';
import { Info } from '@app/components';

interface Props {
  params: Partial<Tender>;
}

function ContractTenderSearch(props: Props) {
  const { params: defaultParams } = props;
  const onClickTender = useCallback((item: Tender) => () => {}, []);

  const renderItem = useCallback(
    (item: Tender) => {
      return (
        <button
          className="bg-muted rounded-lg border-none outline-none cursor-pointer flex gap-6 p-4 box-border text-left w-full hover:bg-accent transition"
          onClick={onClickTender(item)}
        >
          <Info
            label="Наименование объявления"
            value={item.name}
            small={true}
          />
          <Info label="Дата создания" value={item.name} small={true} />
          <Info
            label="Статус"
            value={TenderStatusNames[item.status]}
            small={true}
          />
        </button>
      );
    },
    [onClickTender]
  );

  const getData = useCallback(
    (params: PageableParams) => {
      return getTenders({
        ...params,
        ...defaultParams,
      });
    },
    [defaultParams]
  );

  return (
    <SearchTemplate<Tender>
      getData={getData}
      renderItem={renderItem}
      horizontal={true}
      viewControl={false}
    />
  );
}

export default memo(ContractTenderSearch);
